var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.element == "h1"
      ? _c("h1", {
          staticClass: "h2 title",
          domProps: { innerHTML: _vm._s(_vm.returnTitle) }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.element == "div"
      ? _c("div", {
          staticClass: "my-4",
          domProps: { innerHTML: _vm._s(_vm.returnDescription) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }